import { Link } from "react-router-dom";
import { Typography, Button, Box } from "@mui/material";
import Logo from "@/components/UI-Kit/Logo";
import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive.ts";
import Socials from "@/components/ContactUs/Contacts/Socials";

const FooterLogo = () => {
  const isDesktop = useResponsive("up", "md");

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={{ xs: "center", md: "space-between" }}
      gap={3}
      mb={{ xs: 5.5, md: 0 }}
      height="100%"
    >
      <Logo type="light" width={172} height={32} />

      {isDesktop &&
        <Box
            display="flex"
            justifyContent={{ xs: "center", md: "space-between" }}
            gap={2}
            sx={{ width: '152px', height: '20px', marginBottom: "3rem", }}
        >
          <Socials isVisableColor/>
        </Box>
      }

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ maxWidth: { xs: "auto", md: 160 } }}
        component={Link}
        to={ROUTES.contactUs}
      >
        <Typography
          variant="subtitle1"
          component="span"
          fontWeight={700}
          fontSize={16}
          color="inherit"
        >
          Book A Demo
        </Typography>
      </Button>
    </Box>
  );
};

export default FooterLogo;
